export default "__VITE_ASSET__9OQX6YvD__"